import { useAmn } from "../../contexts/AmnContext";
import { sendActivity } from "../../utils/globalUtils";
import NextButton from "./NextButton";

const Debrief = () => {
  const amn = useAmn()

  const closeEnvironment = () => {
    const menu: HTMLElement | null = document.querySelector("#retorik-menu");
    if (menu) menu.style.display = "";
    amn.setEnvironmentChoice(false);
    sendActivity({
      type:"event",
      name: 'CHU_Event_Close_EnvironmentSelection',
    });
  }

  return (
    <>
      <div className={`ec-debrief ${amn.showEnvironmentChoiceButton ? "showButton" : ""}`}>
        <h2 className="ec-debrief__title">
          E <span>comme</span> Environnement
        </h2>
        <div className="ec-debrief__content">
          <ul>
            <li>Lieu calme, favorisant une certaine intimité</li>
            <li>Si en chambre, tirer les rideaux</li>
            <li>
              Protéger des nuisances récurrentes (couper bips et téléphones,
              éteindre la télé, la radio)
            </li>
            <li>Se rendre disponible émotionnellement</li>
            <li>S'asseoir</li>
            <li>Disposition en rond optimale, autour d'une table</li>
            <li>
              Connaître le dossier du patient, s'assurer de ses connaissances au
              sujet de la pathologie
            </li>
            <li>
              Pensez à disposer des boissons fraiches et chaudes et à les proposer au patient si besoin.
            </li>
          </ul>
          {/* <button className="ec-navigation ec-navigation__end" onClick={handleClick}>Continuer</button> */}
        </div>
      </div>
      {
        amn.showEnvironmentChoiceButton && 
          <NextButton onClick={closeEnvironment}>Suivant</NextButton>
      }
    </>
  );
};

export default Debrief;
